<template>
  <v-select
      v-bind="$attrs"
      :items="items"
      dense
      @input="$emit('input', $event !== '' ? $event : null)"
      :label=label
      hide-details
  >
  </v-select>
</template>

<script>

export default {
  name: 'MaterialLifecycleSelect',
  inheritAttrs: false,
  props: {
    label: {default: null},
  },

  components: {},

  computed: {
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {
      items: [
        {value: 1, text: 'Registration'},
        {value: 2, text: 'Available'},
        {value: 3, text: 'Reserved'},
        {value: 4, text: 'Commissioned'},
        {value: 5, text: 'Prepared'},
        {value: 6, text: 'Spliced'},
        {value: 7, text: 'Production'},
        {value: 8, text: 'ProductionFinished'},
        {value: 9, text: 'Blocked'},
        {value: 10, text: 'UsedUp'},
        {value: 11, text: 'ReadyToShip'},
        {value: 12, text: 'Shipped'},
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
